import { useSelector } from 'react-redux';
import { CircleUserRound as CircleUserRoundIcon } from 'lucide-react';
import { RefreshCw as RefreshCwIcon } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { resetSpecificSlices } from '@/store/storeUtils';

import { remountApp } from '@/utils/remountApp';
import Button from '@/components/Button/Button';
import SmartTooltip from '@/components/Tooltip/SmartTooltip';

const AppHeader = ({ loading, CurrentIcon, currentRoute }) => {
    const userData = useSelector((state) => state.user.userData);
    const dispatch = useDispatch();

    const HeaderSkeleton = () => (
        <div className="w-full flex items-center justify-between">
            <div className="flex items-center gap-4 animate-pulse">
                <div className="bg-gray-400 w-8 h-8 rounded" />
                <div className="bg-gray-400 h-5 w-32 rounded" />
            </div>

            <Button
                variant="primary"
                appearance="outline"
                icon={RefreshCwIcon}
                disabled
                className="border-none !rounded-full aspect-square !px-2"
            ></Button>
        </div>
    );

    const clearStoreAndReload = () => {
        resetSpecificSlices(dispatch, ['numberManagement', 'availableUsers']);

        remountApp();
    };

    return (
        <div className="bg-white flex items-center min-h-[60px] h-[60px] px-8 py-2 mb-4 shadow-md">
            {loading ? (
                <HeaderSkeleton />
            ) : (
                <div className="w-full flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        {CurrentIcon && (
                            <CurrentIcon
                                size={30}
                                color="#183995"
                                className="me-4"
                            />
                        )}
                        <span className="text-xl font-bold text-primary-800">
                            {currentRoute?.title || 'Untitled Page'}
                        </span>
                    </div>

                    {process.env.NODE_ENV === 'development' && (
                        <div className="flex flex-col items-center gap-1 text-sm">
                            <div className="flex items-center gap-1 text-secondary">
                                <CircleUserRoundIcon size={16} />

                                <span>{userData?.userName}</span>
                            </div>
                            <span className="text-secondary">
                                {userData?.email}
                            </span>
                        </div>
                    )}

                    <SmartTooltip content="Refresh">
                        <Button
                            variant="primary"
                            appearance="outline"
                            icon={RefreshCwIcon}
                            onClick={clearStoreAndReload}
                            disabled={loading}
                            iconSize={30}
                            className="border-none !rounded-full aspect-square !px-2"
                        ></Button>
                    </SmartTooltip>
                </div>
            )}
        </div>
    );
};

export default AppHeader;
